// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button__root--Jk59j {
    --icon-size: 24px; 
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    transition: color 0.25s ease-in-out, border-color 0.25s ease-in-out, background-color 0.25s ease-in-out;
    white-space: nowrap;
    text-transform: uppercase;
    color: var(--main-color);
    outline: none;
    border: none;
    background-color: transparent;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 12px;
    font-weight: 600;
    line-height: 2;
    letter-spacing: 0.6px;
}

    .Button__root--Jk59j .Button__icon--G4Rlx > svg {
        width: var(--icon-size);
        height: var(--icon-size);
    }

.Button__primary--u4HHB {
    background-color: var(--main-color);
    color: var(--dark-secondary-new-color);
}

@media (hover: hover) and (pointer: fine) {
        .Button__primary--u4HHB:hover, .Button__primary--u4HHB:active {
            background-color: var(--secondary-color);
        }
    }

.Button__primary--u4HHB .Button__icon--G4Rlx {
        color: var(--dark-secondary-new-color);
    }

.Button__primary--u4HHB .Button__icon--G4Rlx.Button__fill--X5gVl svg path {
            fill: var(--dark-secondary-new-color);
        }

.Button__primary--u4HHB .Button__icon--G4Rlx.Button__stroke--R3v29 svg path {
            stroke: var(--dark-secondary-new-color);
        }

.Button__primary--u4HHB.Button__disabled--NM57S {
        background-color: #323540;
        pointer-events: none;
    }

.Button__secondary--fKu0_ {
    color: var(--main-color);
    border: 1px solid var(--main-color);
}

@media (hover: hover) and (pointer: fine) {
        .Button__secondary--fKu0_:hover {
            border-color: var(--secondary-color);
            color: var(--secondary-color);
        }
                .Button__secondary--fKu0_:hover .Button__icon--G4Rlx.Button__fill--X5gVl svg path {
                    fill: var(--secondary-color);
                }
        
                .Button__secondary--fKu0_:hover .Button__icon--G4Rlx.Button__stroke--R3v29 svg path {
                    stroke: var(--secondary-color);
                }

        .Button__secondary--fKu0_:active {
            border-color: var(--secondary-color);
            color: var(--secondary-color);
        }
                .Button__secondary--fKu0_:active .Button__icon--G4Rlx.Button__fill--X5gVl svg path {
                    fill: var(--secondary-color);
                }
        
                .Button__secondary--fKu0_:active .Button__icon--G4Rlx.Button__stroke--R3v29 svg path {
                    stroke: var(--secondary-color);
                }
    }

.Button__secondary--fKu0_ .Button__icon--G4Rlx.Button__fill--X5gVl svg path {
            fill: var(--main-color);
        }

.Button__secondary--fKu0_ .Button__icon--G4Rlx.Button__stroke--R3v29 svg path {
            stroke: var(--main-color);
        }

.Button__secondary--fKu0_.Button__disabled--NM57S {
        border-color: var(--dark-tertiary-new-color);
        color: var(--dark-tertiary-new-color);
        pointer-events: none;
    }

.Button__tertiary--RRGdH {
    background-color: var(--dark-secondary-new-color);
    color: var(--dark-fourth-new-color);
    border: 1px solid var(--dark-primary-color);
    --icon-color: var(--dark-fourth-new-color);
}

.Button__tertiary--RRGdH .Button__icon--G4Rlx.Button__fill--X5gVl svg path {
            fill: var(--icon-color);
        }

.Button__tertiary--RRGdH .Button__icon--G4Rlx.Button__stroke--R3v29 svg path {
            stroke: var(--icon-color);
        }

@media (hover: hover) and (pointer: fine) {
        .Button__tertiary--RRGdH:hover {
            color: var(--secondary-color);
            --icon-color: var(--secondary-color);
        }
    }

.Button__tertiary--RRGdH:active {
        color: var(--dark-secondary-new-color);
        background-color: var(--secondary-color);
        border-color: var(--secondary-color);
        --icon-color: var(--dark-secondary-new-color);
    }

.Button__tertiary--RRGdH.Button__disabled--NM57S {
        pointer-events: none;
        border-color: var(--dark-tertiary-new-color);
        background-color: var(--dark-secondary-new-color);
        color: var(--dark-tertiary-new-color);
        --icon-color: var(--dark-tertiary-new-color);
    }

.Button__fourth--NgQv2 {
    border: 1px solid #323540;
    color: var(--dark-fourth-new-color);
}

.Button__fourth--NgQv2 .Button__icon--G4Rlx.Button__fill--X5gVl svg path {
            fill: var(--dark-fourth-new-color);
        }

.Button__fourth--NgQv2 .Button__icon--G4Rlx.Button__stroke--R3v29 svg path {
            stroke: var(--dark-fourth-new-color);
        }

@media (hover: hover) and (pointer: fine) {
        .Button__fourth--NgQv2:hover, .Button__fourth--NgQv2:active {
            color: var(--secondary-color);
        }
                .Button__fourth--NgQv2:hover .Button__icon--G4Rlx.Button__fill--X5gVl svg path, .Button__fourth--NgQv2:active .Button__icon--G4Rlx.Button__fill--X5gVl svg path {
                    fill: var(--secondary-color);
                }
        
                .Button__fourth--NgQv2:hover .Button__icon--G4Rlx.Button__stroke--R3v29 svg path, .Button__fourth--NgQv2:active .Button__icon--G4Rlx.Button__stroke--R3v29 svg path {
                    stroke: var(--secondary-color);
                }
    }

.Button__fourth--NgQv2.Button__disabled--NM57S {
        border-color: var(--dark-tertiary-new-color);
        color: var(--dark-tertiary-new-color);
        pointer-events: none;
    }

.Button__fourth--NgQv2.Button__disabled--NM57S .Button__icon--G4Rlx.Button__fill--X5gVl svg path {
                fill: var(--dark-tertiary-new-color);
            }

.Button__fourth--NgQv2.Button__disabled--NM57S .Button__icon--G4Rlx.Button__stroke--R3v29 svg path {
                stroke: var(--dark-tertiary-new-color);
            }

.Button__fifth--GRaQO {
    color: var(--dark-secondary-new-color);
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.6px;
    padding: 8px 12px;
    border-radius: 40px;
    background: linear-gradient(180deg, #FFF2D7 0%, #FFF 6.57%, #FFF5E0 13.43%, #FFECBA 20.06%, #FEA800 52.97%, #FFC100 76.44%, #F90 100%);
    box-shadow: 0px 0px 24px 0px #FFA300;
}

.Button__fifth--GRaQO.Button__disabled--NM57S {
        background: var(--dark-tertiary-new-color);
        box-shadow: none;
        pointer-events: none;
    }

.Button__sixth--xCeUE {
    color: var(--dark-secondary-new-color);
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.6px;
    padding: 8px 12px;
    border-radius: 6px;
    background: linear-gradient(180deg, #FFF2D7 0%, #FFF 6.57%, #FFF5E0 13.43%, #FFECBA 20.06%, #FEA800 52.97%, #FFC100 76.44%, #F90 100%);
    box-shadow: 0px 0px 24px 0px #FFA300;
}

.Button__sixth--xCeUE.Button__disabled--NM57S {
        background: var(--dark-tertiary-new-color);
        box-shadow: none;
        pointer-events: none;
    }

.Button__premium--P7qeR {
    background-color: var(--premium-dark-color);
    color: var(--premium-solid-color);
}

.Button__gradientText--ZrfAB {
    background-image: var(--premium-gradient);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.Button__withoutLabel--dwjGD {
    padding: 8px;
}

.Button__icon--G4Rlx.Button__fill--X5gVl svg path {
        fill-opacity: 1;
        transition: fill 0.25s ease-in-out;
    }

.Button__icon--G4Rlx.Button__stroke--R3v29 svg path {
        transition: stroke 0.25s ease-in-out;
    }
`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,uGAAuG;IACvG,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AAMzB;;IAJI;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;AAGJ;IACI,mCAAmC;IACnC,sCAAsC;AAwB1C;;AAtBI;QACI;YACI,wCAAwC;QAC5C;IACJ;;AAEA;QACI,sCAAsC;IAS1C;;AAPI;YACI,qCAAqC;QACzC;;AAEA;YACI,uCAAuC;QAC3C;;AAGJ;QACI,yBAAyB;QACzB,oBAAoB;IACxB;;AAGJ;IACI,wBAAwB;IACxB,mCAAmC;AAiDvC;;AA/CI;QACI;YACI,oCAAoC;YACpC,6BAA6B;QAWjC;gBARQ;oBACI,4BAA4B;gBAChC;;gBAEA;oBACI,8BAA8B;gBAClC;;QAIR;YACI,oCAAoC;YACpC,6BAA6B;QAWjC;gBARQ;oBACI,4BAA4B;gBAChC;;gBAEA;oBACI,8BAA8B;gBAClC;IAGZ;;AAGI;YACI,uBAAuB;QAC3B;;AAEA;YACI,yBAAyB;QAC7B;;AAGJ;QACI,4CAA4C;QAC5C,qCAAqC;QACrC,oBAAoB;IACxB;;AAGJ;IACI,iDAAiD;IACjD,mCAAmC;IACnC,2CAA2C;IAC3C,0CAA0C;AAiC9C;;AA9BQ;YACI,uBAAuB;QAC3B;;AAEA;YACI,yBAAyB;QAC7B;;AAGJ;QACI;YACI,6BAA6B;YAC7B,oCAAoC;QACxC;IACJ;;AAEA;QACI,sCAAsC;QACtC,wCAAwC;QACxC,oCAAoC;QACpC,6CAA6C;IACjD;;AAEA;QACI,oBAAoB;QACpB,4CAA4C;QAC5C,iDAAiD;QACjD,qCAAqC;QACrC,4CAA4C;IAChD;;AAGJ;IACI,yBAAyB;IACzB,mCAAmC;AA2CvC;;AAxCQ;YACI,kCAAkC;QACtC;;AAEA;YACI,oCAAoC;QACxC;;AAGJ;QACI;YACI,6BAA6B;QAWjC;gBARQ;oBACI,4BAA4B;gBAChC;;gBAEA;oBACI,8BAA8B;gBAClC;IAGZ;;AAEA;QACI,4CAA4C;QAC5C,qCAAqC;QACrC,oBAAoB;IAWxB;;AARQ;gBACI,oCAAoC;YACxC;;AAEA;gBACI,sCAAsC;YAC1C;;AAKZ;IACI,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,sIAAsI;IACtI,oCAAoC;AAOxC;;AALI;QACI,0CAA0C;QAC1C,gBAAgB;QAChB,oBAAoB;IACxB;;AAGJ;IACI,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,sIAAsI;IACtI,oCAAoC;AAOxC;;AALI;QACI,0CAA0C;QAC1C,gBAAgB;QAChB,oBAAoB;IACxB;;AAGJ;IACI,2CAA2C;IAC3C,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;IACzC,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAGI;QACI,eAAe;QACf,kCAAkC;IACtC;;AAEA;QACI,oCAAoC;IACxC","sourcesContent":[".root {\n    --icon-size: 24px; \n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    cursor: pointer;\n    transition: color 0.25s ease-in-out, border-color 0.25s ease-in-out, background-color 0.25s ease-in-out;\n    white-space: nowrap;\n    text-transform: uppercase;\n    color: var(--main-color);\n    outline: none;\n    border: none;\n    background-color: transparent;\n    border-radius: 6px;\n    padding: 8px 16px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 2;\n    letter-spacing: 0.6px;\n\n    .icon > svg {\n        width: var(--icon-size);\n        height: var(--icon-size);\n    }\n}\n\n.primary {\n    background-color: var(--main-color);\n    color: var(--dark-secondary-new-color);\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover, &:active {\n            background-color: var(--secondary-color);\n        }\n    }\n\n    .icon {\n        color: var(--dark-secondary-new-color);\n\n        &.fill svg path {\n            fill: var(--dark-secondary-new-color);\n        }\n\n        &.stroke svg path {\n            stroke: var(--dark-secondary-new-color);\n        }\n    }\n\n    &.disabled {\n        background-color: #323540;\n        pointer-events: none;\n    }\n}\n\n.secondary {\n    color: var(--main-color);\n    border: 1px solid var(--main-color);\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            border-color: var(--secondary-color);\n            color: var(--secondary-color);\n\n            .icon {\n                &.fill svg path {\n                    fill: var(--secondary-color);\n                }\n        \n                &.stroke svg path {\n                    stroke: var(--secondary-color);\n                }\n            }\n        }\n\n        &:active {\n            border-color: var(--secondary-color);\n            color: var(--secondary-color);\n\n            .icon {\n                &.fill svg path {\n                    fill: var(--secondary-color);\n                }\n        \n                &.stroke svg path {\n                    stroke: var(--secondary-color);\n                }\n            }\n        }\n    }\n\n    .icon {\n        &.fill svg path {\n            fill: var(--main-color);\n        }\n\n        &.stroke svg path {\n            stroke: var(--main-color);\n        }\n    }\n\n    &.disabled {\n        border-color: var(--dark-tertiary-new-color);\n        color: var(--dark-tertiary-new-color);\n        pointer-events: none;\n    }\n}\n\n.tertiary {\n    background-color: var(--dark-secondary-new-color);\n    color: var(--dark-fourth-new-color);\n    border: 1px solid var(--dark-primary-color);\n    --icon-color: var(--dark-fourth-new-color);\n\n    .icon {\n        &.fill svg path {\n            fill: var(--icon-color);\n        }\n\n        &.stroke svg path {\n            stroke: var(--icon-color);\n        }\n    }\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            color: var(--secondary-color);\n            --icon-color: var(--secondary-color);\n        }\n    }\n\n    &:active {\n        color: var(--dark-secondary-new-color);\n        background-color: var(--secondary-color);\n        border-color: var(--secondary-color);\n        --icon-color: var(--dark-secondary-new-color);\n    }\n\n    &.disabled {\n        pointer-events: none;\n        border-color: var(--dark-tertiary-new-color);\n        background-color: var(--dark-secondary-new-color);\n        color: var(--dark-tertiary-new-color);\n        --icon-color: var(--dark-tertiary-new-color);\n    }\n}\n\n.fourth {\n    border: 1px solid #323540;\n    color: var(--dark-fourth-new-color);\n\n    .icon {\n        &.fill svg path {\n            fill: var(--dark-fourth-new-color);\n        }\n\n        &.stroke svg path {\n            stroke: var(--dark-fourth-new-color);\n        }\n    }\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover, &:active {\n            color: var(--secondary-color);\n\n            .icon {\n                &.fill svg path {\n                    fill: var(--secondary-color);\n                }\n        \n                &.stroke svg path {\n                    stroke: var(--secondary-color);\n                }\n            }\n        }\n    }\n\n    &.disabled {\n        border-color: var(--dark-tertiary-new-color);\n        color: var(--dark-tertiary-new-color);\n        pointer-events: none;\n\n        .icon {\n            &.fill svg path {\n                fill: var(--dark-tertiary-new-color);\n            }\n    \n            &.stroke svg path {\n                stroke: var(--dark-tertiary-new-color);\n            }\n        }\n    }\n}\n\n.fifth {\n    color: var(--dark-secondary-new-color);\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: 0.6px;\n    padding: 8px 12px;\n    border-radius: 40px;\n    background: linear-gradient(180deg, #FFF2D7 0%, #FFF 6.57%, #FFF5E0 13.43%, #FFECBA 20.06%, #FEA800 52.97%, #FFC100 76.44%, #F90 100%);\n    box-shadow: 0px 0px 24px 0px #FFA300;\n\n    &.disabled {\n        background: var(--dark-tertiary-new-color);\n        box-shadow: none;\n        pointer-events: none;\n    }\n}\n\n.sixth {\n    color: var(--dark-secondary-new-color);\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: 0.6px;\n    padding: 8px 12px;\n    border-radius: 6px;\n    background: linear-gradient(180deg, #FFF2D7 0%, #FFF 6.57%, #FFF5E0 13.43%, #FFECBA 20.06%, #FEA800 52.97%, #FFC100 76.44%, #F90 100%);\n    box-shadow: 0px 0px 24px 0px #FFA300;\n\n    &.disabled {\n        background: var(--dark-tertiary-new-color);\n        box-shadow: none;\n        pointer-events: none;\n    }\n}\n\n.premium {\n    background-color: var(--premium-dark-color);\n    color: var(--premium-solid-color);\n}\n\n.gradientText {\n    background-image: var(--premium-gradient);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.withoutLabel {\n    padding: 8px;\n}\n\n.icon {\n    &.fill svg path {\n        fill-opacity: 1;\n        transition: fill 0.25s ease-in-out;\n    }\n\n    &.stroke svg path {\n        transition: stroke 0.25s ease-in-out;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Button__root--Jk59j`,
	"icon": `Button__icon--G4Rlx`,
	"primary": `Button__primary--u4HHB`,
	"fill": `Button__fill--X5gVl`,
	"stroke": `Button__stroke--R3v29`,
	"disabled": `Button__disabled--NM57S`,
	"secondary": `Button__secondary--fKu0_`,
	"tertiary": `Button__tertiary--RRGdH`,
	"fourth": `Button__fourth--NgQv2`,
	"fifth": `Button__fifth--GRaQO`,
	"sixth": `Button__sixth--xCeUE`,
	"premium": `Button__premium--P7qeR`,
	"gradientText": `Button__gradientText--ZrfAB`,
	"withoutLabel": `Button__withoutLabel--dwjGD`
};
export default ___CSS_LOADER_EXPORT___;
